"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectAddress = exports.selectOutage = exports.INFOBOX_CLOSE = exports.INFOBOX_SELECT_ADDRESS = exports.INFOBOX_SELECT_OUTAGE = void 0;

var _actions = require("kmap-redux/dist/actions");

var INFOBOX_SELECT_OUTAGE = 'INFOBOX_SELECT_OUTAGE';
exports.INFOBOX_SELECT_OUTAGE = INFOBOX_SELECT_OUTAGE;
var INFOBOX_SELECT_ADDRESS = 'INFOBOX_SELECT_ADDRESS';
exports.INFOBOX_SELECT_ADDRESS = INFOBOX_SELECT_ADDRESS;
var INFOBOX_CLOSE = 'CLOSE_INFOBOX';
exports.INFOBOX_CLOSE = INFOBOX_CLOSE;

var selectOutage = function selectOutage(e) {
  return function (dispatch) {
    // dispatch(clearSelectedIcon());
    dispatch((0, _actions.removeSelected)());
    dispatch({
      type: INFOBOX_SELECT_OUTAGE,
      outage: e
    });
    dispatch((0, _actions.selectElement)(e.geom, e.type));
  };
};

exports.selectOutage = selectOutage;

var selectAddress = function selectAddress(_ref) {
  var geometry = _ref.geometry,
      address = _ref.address;
  return function (dispatch) {
    // dispatch(clearSelectedIcon());
    dispatch((0, _actions.removeSelected)());
    var geom = {
      geom: {
        points: [[[geometry._geometry.lat, geometry._geometry.lng]]]
      }
    };
    var mapView = dispatch((0, _actions.getView)());
    var addressObject = {
      address: address,
      alias: '',
      view: mapView.view,
      bookmarked: false
    };
    dispatch({
      type: INFOBOX_SELECT_ADDRESS,
      address: addressObject
    });
    dispatch((0, _actions.selectElement)(geom.geom, 'POINT'));
  };
};

exports.selectAddress = selectAddress;